module.exports = __webpack_public_path__ + "img/imagen4.6af4c522.png";